import React, {Component} from "react";
import {Table} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getPaymentStatistics} from "../../../actions/thunks.js";
import {resetAssignmentsFilters} from "../../../actions/actions.js";
import Piechart from "./PieChart";
import {formatAmount} from "utils";
import { Link,  browserHistory} from 'react-router';
import moment from "moment";
import { TTP_HOME_URL, TTP_PAYMENT_URL } from 'Config';

class PaymentStatisticsBloc extends Component {


  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getPaymentStatistics(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }

  componentDidUpdate(prevProps, prevState)
  {
    if(prevProps.statisticsFilter !== this.props.statisticsFilter || prevProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {

      this.props.getPaymentStatistics(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  getEventDates = () => {

    let result = [];

    if(this.props.statisticsFilter && this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length >0) {

      this.props.statisticsFilter.appRefs.forEach(id => {

        if (this.props.appRef && this.props.appRef.length > 0) {
          let appRefFilter = this.props.appRef.find(item => item.id == id);
          if (appRefFilter) {
            result.push(moment(appRefFilter.eventDate.date).format('YYYY'))
          }
        }
      });
    }

    return result;
  }

  render() {
    const {paymentInfos } = this.props;


    let amoutOgone = paymentInfos && paymentInfos.items && paymentInfos.items['OGONE'] && paymentInfos.items['OGONE'].amount ? paymentInfos.items['OGONE'].amount : 0;
    let amoutVirement = paymentInfos && paymentInfos.items && paymentInfos.items['BANK_TRANSFER'] && paymentInfos.items['BANK_TRANSFER'].amount ? paymentInfos.items['BANK_TRANSFER'].amount : 0;
    let amountManual = paymentInfos && paymentInfos.items && paymentInfos.items['MANUAL'] && paymentInfos.items['MANUAL'].amount ? paymentInfos.items['MANUAL'].amount : 0;
    let amountPayConiq = paymentInfos && paymentInfos.items && paymentInfos.items['PAY_CONIQ'] && paymentInfos.items['PAY_CONIQ'].amount ? paymentInfos.items['PAY_CONIQ'].amount : 0;
    let amountMangoPay = paymentInfos && paymentInfos.items && paymentInfos.items['MANGO_PAY'] && paymentInfos.items['MANGO_PAY'].amount ? paymentInfos.items['MANGO_PAY'].amount : 0;


    const showAssignmentDate = this.props.statisticsFilter.year.length > 0 ? `period=[${this.props.statisticsFilter.year.join(',')}],` : (this.getEventDates().length > 0 ? `period=[${this.getEventDates().join(',')}],` :``);
    const showAppRef = this.props.statisticsFilter.appRefs.length > 0 ? `,appRefs=[${this.props.statisticsFilter.appRefs.join(',')}]` : ``;

    return (
      <div className="fact-bloc">

        <div className="title">
          {_('Assignments')}
        </div>

        <Row gutter={16}>
          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('OGONE')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/Ogone-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['OGONE'] && paymentInfos.items['OGONE'].amount ? formatAmount(paymentInfos.items['OGONE'].amount) : 0}
                    </div>
                  </div>

              </div>
            </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('Pay Coniq')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/Payconiq-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['PAY_CONIQ'] && paymentInfos.items['PAY_CONIQ'].amount ? formatAmount(paymentInfos.items['PAY_CONIQ'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('Mango Pay')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/mangopay-Big.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['MANGO_PAY'] && paymentInfos.items['MANGO_PAY'].amount ? formatAmount(paymentInfos.items['MANGO_PAY'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>


          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('BANK_TRANSFER')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/BANK-TRANSFER.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['BANK_TRANSFER'] && paymentInfos.items['BANK_TRANSFER'].amount ? formatAmount(paymentInfos.items['BANK_TRANSFER'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>


          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                {_('MANUAL')}
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className=" pl-4  ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/MANUAL.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {paymentInfos && paymentInfos.items && paymentInfos.items['MANUAL'] && paymentInfos.items['MANUAL'].amount ? formatAmount(paymentInfos.items['MANUAL'].amount) : 0}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

          <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
            <div className="gutter-box payment-bloc-background">
              <div className="sub-title-facturation">
                Total
              </div>
              <div className="line"/>

              <div className="pl-4 mt-10">

                <div className="pl-4 ca-cantainer">
                  <div className="flex items-center justify-center ">
                    <img src={"/img/icons/TOTAL2.svg"}/>
                  </div>

                  <div className="flex items-center justify-center flex-col ml-8 mt-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount">
                      {formatAmount(parseInt(amountManual) + parseInt(amoutVirement)+ parseInt(amoutOgone)+ parseInt(amountMangoPay)+ parseInt(amountPayConiq))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Col>

        </Row>

      </div>);
  }
}

const mapStateToProps = state => ({
  paymentInfos: state.paymentInfos,
  statisticsFilter: state.filters.statisticsFilter,
  eventStatsFilter: state.filters.eventStatsFilter,
  appRef: state.appRefFilter.items,
  auth: state.auth,
});

const mapDispatchToProps = {
  getPaymentStatistics,
  resetAssignmentsFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentStatisticsBloc);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/PaymentStatisticsBloc.js